import { Outlet } from "react-router-dom";

export default function ActivitiesListOutlet() {
  return <Outlet />;
}
